// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3T_nv","footer":"ModalError_footer__P6cmU"};